package com.exura.features.plandefinition.data.mappers.plandefinition

import com.exura.features.plandefinition.data.remote.dto.plan.PreparationPlanDto
import com.exura.features.plandefinition.domain.model.plan.PreparationPlan
import dev.gitlive.firebase.firestore.CollectionReference

class PreparationPlanMappers : PlanMappers<PreparationPlan, PreparationPlanDto> {
    override fun toDto(model: PreparationPlan): PreparationPlanDto {
        return PreparationPlanDto(
            title = model.title,
            description = model.description,
            durationInDays = model.durationInDays(),
            imageUrl = model.imageUrl,
        )
    }

    override fun toDomain(dto: PreparationPlanDto, collection: CollectionReference?, id: String?): PreparationPlan {
        return PreparationPlan(
            firebaseDocId = id,
            firebaseDocPrefix = collection,
            title = dto.title,
            description = dto.description,
            collections = emptyList(),
            directSeries = emptyList(),
            imageUrl = dto.imageUrl,
        )
    }
}
